import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const employerService = {
  // Get all employers
  getAllEmployers: async (page = 1) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.EMPLOYERS}?page=${page}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get employer by ID
  getEmployerById: async (employerId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.EMPLOYER_BY_ID(employerId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get employer stats
  getEmployerStats: async (employerId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.EMPLOYER_STATS(employerId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new employer
  createEmployer: async (employerData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.EMPLOYERS}`, employerData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update employer
  updateEmployer: async (employerId, employerData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.EMPLOYER_BY_ID(employerId)}`, employerData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete employer
  deleteEmployer: async (employerId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.EMPLOYER_BY_ID(employerId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default employerService;